import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=0ef38202&scoped=true"
import script from "./TermsOfService.vue?vue&type=script&lang=js"
export * from "./TermsOfService.vue?vue&type=script&lang=js"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=0ef38202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef38202",
  null
  
)

export default component.exports